export default __webpack_public_path__ + "static/media/pdf.bf1d30a8.png";